import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledFeaturedProperties = styled.div`
  ul {
    list-style-type: none !important;
  }

  .card-texts {
    &::before {
      margin-bottom: ${toRem(8)};
      line-height: normal;
      font-weight: 500;
      padding: ${toRem(8)} 0;
    }
  }

  .brand-logo-BR::before,
  .brand-logo-br::before,
  .brand-logo-MC::before,
  .brand-logo-mc::before,
  .brand-logo-SI::before,
  .brand-logo-si::before {
    font-size: ${toRem(32)};
  }

  .card-up-header {
    .carousal_header {
      .m-ellipsis-2lines {
        font-size: ${toRem(16)};
        line-height: ${toRem(20)};
      }
    }
  }
`;
